/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
* Describes a numeric field to be displayed on a Form, Grid or Table
*/
import { formatCurrency, formatNumber, formatPercent } from "@angular/common";
import { CellOpts, Field, FieldType } from '@src/app/shared/field/Field';


export class NumberOpts {
    format?: 'decimal' | 'percent' | 'currency' | 'plain';
    formatParms?: string;
    width?: number;
    step? = 1;
    blankZero?: boolean;
    style?: Record<string, string>
}


export class NumberField extends Field {

    type: FieldType = 'number';
    condensed = false;
    total = false;

    numberOpts: NumberOpts = { format: 'decimal' }; //new NumberOpts();

    cellOpts: CellOpts = { style: 'justify-content: flex-end; text-align: right; padding-right: 5px' };
    footer: { style: string};

    constructor(defaultOptions: Partial<NumberField>, moreOptions: Partial<NumberField> = {}) {
        super(defaultOptions, moreOptions);
        if (moreOptions.cellOpts) {
            this.cellOpts = { ...this.cellOpts, ...moreOptions.cellOpts };
        }
        if (moreOptions.condensed) {
            this.condensed = moreOptions.condensed;
        }
        if (moreOptions.total) {
            this.total = moreOptions.total;
        }
        if (moreOptions.footer?.style) {
            this.footer.style = moreOptions.footer.style;
        } else {
            this.footer.style = 'justify-content: flex-end; text-align: right; padding-right: 5px' 
        }
        this.defaultLabels();
    }

    getStringNumericValue(val: string) {
        return +val.replace(/[^\d.-]/g, '');
    }
    blankZero() {
        this.numberOpts.blankZero = true;
        return this;
    }

    formatValue(val) {
        if (this.numberOpts.blankZero && (!val)) {
            return '';
        } else if (this.numberOpts.format === 'percent') {
            return formatPercent(val, Field.locale, this.numberOpts.formatParms);
        } else if (this.numberOpts.format === 'decimal') {
            return formatNumber(val, Field.locale, this.numberOpts.formatParms);
        } else if (this.numberOpts.format === 'currency') {
            return formatCurrency(val, Field.locale, Field.currencySymbol, Field.currencyCode, this.numberOpts.formatParms);
        }
        return super.formatValue(val);
    }
}
